class ClayBrands extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.cards = [...this.querySelectorAll("[data-clay-brand-card]")];
    if (!this.cards.length) return;

    this.activeIndex = Math.floor(this.cards.length / 2);
    this.desktop = window.matchMedia("(min-width: 750px)");
    this.onBreakpointChange = () => this.update();
    this.onPointerLeave = () => this.setActive(Math.floor(this.cards.length / 2));
    this.cardEvents = this.cards.map((card, index) => {
      const activate = () => this.setActive(index);
      card.addEventListener("pointerenter", activate);
      card.addEventListener("focusin", activate);
      return { card, activate };
    });

    this.addEventListener("pointerleave", this.onPointerLeave);
    this.desktop.addEventListener?.("change", this.onBreakpointChange);
    this.resizeObserver = new ResizeObserver(() => this.updateGeometry());
    this.resizeObserver.observe(this);
    this.updateGeometry();
    this.update();
  }

  disconnectedCallback() {
    this.removeEventListener("pointerleave", this.onPointerLeave);
    this.desktop?.removeEventListener?.("change", this.onBreakpointChange);
    this.resizeObserver?.disconnect();
    this.cardEvents?.forEach(({ card, activate }) => {
      card.removeEventListener("pointerenter", activate);
      card.removeEventListener("focusin", activate);
    });
  }

  setActive(index) {
    if (index === this.activeIndex) return;
    this.activeIndex = index;
    this.update();
  }

  updateGeometry() {
    if (!this.desktop.matches) {
      this.style.removeProperty("--cc-brand-width");
      this.style.removeProperty("--cc-brand-overlap");
      return;
    }

    const count = this.cards.length;
    const trackWidth = Math.min(this.clientWidth, 1100);
    const overlap = count > 1 ? Math.min(62.5, trackWidth * 0.057) : 0;
    const cardWidth = (trackWidth + overlap * (count - 1)) / count;

    this.style.setProperty("--cc-brand-width", `${cardWidth.toFixed(2)}px`);
    this.style.setProperty("--cc-brand-overlap", `${overlap.toFixed(2)}px`);
  }

  update() {
    this.updateGeometry();

    if (!this.desktop.matches) {
      this.cards.forEach((card) => {
        card.classList.remove("is-active");
        card.style.removeProperty("--cc-brand-scale");
        card.style.removeProperty("z-index");
      });
      return;
    }

    const denominator = Math.max(this.cards.length - 1, 1);
    this.cards.forEach((card, index) => {
      const distance = this.activeIndex - index;
      const absoluteDistance = Math.abs(distance);
      const scale = 1.2 - (0.4 * absoluteDistance) / denominator;

      card.classList.toggle("is-active", index === this.activeIndex);
      card.style.setProperty("--cc-brand-scale", scale.toFixed(3));
      card.style.zIndex = String(this.cards.length - absoluteDistance);
    });
  }
}

if (!customElements.get("clay-brands")) {
  customElements.define("clay-brands", ClayBrands);
}
